import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { name: String };

  add() {
    this.element.setAttribute(`data-${this.nameValue}`, "");
  }
}
